var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06665 4.53333C5.06665 4.23878 5.30543 4 5.59998 4H18.4C18.6945 4 18.9333 4.23878 18.9333 4.53333V19.4667C18.9333 19.6515 18.8376 19.8232 18.6804 19.9203C18.5231 20.0175 18.3268 20.0264 18.1615 19.9437L16.2667 18.9963L14.3718 19.9437C14.2217 20.0188 14.045 20.0188 13.8948 19.9437L12 18.9963L10.1052 19.9437C9.95502 20.0188 9.77828 20.0188 9.62814 19.9437L7.73332 18.9963L5.8385 19.9437C5.67317 20.0264 5.47683 20.0175 5.31959 19.9203C5.16236 19.8232 5.06665 19.6515 5.06665 19.4667V4.53333ZM8.26665 9.33333H10.4V8.26667H8.26665V9.33333ZM12.5333 9.33333H15.7333V8.26667H12.5333V9.33333ZM10.4 12.5333H8.26665V11.4667H10.4V12.5333ZM12.5333 12.5333H15.7333V11.4667H12.5333V12.5333ZM15.7333 15.7333H12.5333V14.6667H15.7333V15.7333Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/TransactionsIcon.0c1d2eac057db34761521955abe346ab.svg";
export { ForwardRef as ReactComponent };